import type { FunctionComponent } from 'react';

import { useSettingsSlice } from '../../../../store/slices/settings/selectors';
import { formatNumber } from '../../../../utils/formatters';
import { CurrencyConnected } from '../../../currency/CurrencyConnected';
import type { Limits } from '../../types';

import { Limit } from './Limit';

export interface LimitConnectedProps {
  limits: Limits;
}

export const LimitConnected: FunctionComponent<LimitConnectedProps> = ({ limits: [min, max] }) => {
  const locale = useSettingsSlice.currentLanguage();

  return (
    <Limit
      min={<CurrencyConnected value={min} avoidTrailingZero />}
      max={formatNumber(locale, max, { avoidTrailingZero: true })}
    />
  );
};
